import { useContext } from 'react';
import { UserAccountContext } from '@pkgs/components/providers/UserAccountProvider';

export const useUserAcountAuth = () => {
  const ctx = useContext(UserAccountContext);

  if (ctx === undefined) {
    throw new Error('useUserAcountAuth used outside of ContextProvider!');
  } else {
    return ctx;
  }
};
